import { Typography } from '@mui/material'
import React from 'react'

import { CompanyNameAlternatives } from 'components/authentication/registration/self-service/CompanyNameAlternatives'

export const ConflictPrompt: React.FC<{
  alternateNames: string[]
  companyName: string | string[]
  handleClearConflict: () => void
  handleCompanyNameChange: (name: string) => void
}> = ({
  alternateNames,
  companyName,
  handleClearConflict,
  handleCompanyNameChange
}) => (
  <>
    <Typography data-test-conflict-prompt-header>
      We're unable to create the company <strong>{companyName}</strong>
    </Typography>

    <Typography data-test-conflict-prompt-description>
      Choose a suggested company name below:
    </Typography>

    <CompanyNameAlternatives
      alternateNames={alternateNames}
      handleClearConflict={handleClearConflict}
      handleCompanyNameChange={handleCompanyNameChange}
    />
  </>
)
